export default __webpack_public_path__ + "static/media/edit-note.a2f20545.svg";